// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3vRz1","bigColWidth":"Table_bigColWidth__3YF1-","biggerColWidth":"Table_biggerColWidth__2zH10","row":"Table_row__ev4kF","col":"Table_col__2_6xv"};